<template>
  <ListPage tabName="reviewed"></ListPage>
</template>
<script>
import ListPage from "../Component/ListPage";
export default {
  components: {
    ListPage
  }
};
</script>
